import { PayloadAction } from '@reduxjs/toolkit';
import { get } from 'lodash';
import { IWithId } from '../type';

export const createDataSuccessToObjectReducer = <T extends IWithId, TStateSlice>(
  statekey: string,
  datapath: string
) => (state: TStateSlice, action: PayloadAction<any>) => {
  const data: T[] = get(action, `payload.data.${datapath}`, []);
  if (data.length > 0) {
    state[statekey] = data[0];
  } else {
    state[statekey] = null;
  }
  return state;
};
